import { RouterPathConfig } from './router-path.config';

export class FileManagementConstants {
    public static STORAGE_UNIT = {
        title: 'storageUnits',
        path: RouterPathConfig.FILE_MANAGEMENT_PATH.STORAGE_UNIT,
        viewType: 'storageUnits',
        status: 0,
        count: undefined,
        name: 'STORAGE_UNIT',
        icon: 'storageunit.svg'
    };
    public static ACTIVITY = {
        title: 'activity',
        path: RouterPathConfig.FILE_MANAGEMENT_PATH.ACTIVITY,
        viewType: 'activity',
        status: 0,
        count: undefined,
        name: 'ACTIVITY',
        icon: 'activity.svg'
    };
    public static SHARED_FILES = {
        title: 'sharedfiles',
        path: RouterPathConfig.FILE_MANAGEMENT_PATH.SHARED_FILES,
        viewType: 'sharedfiles',
        status: 0,
        count: undefined,
        name: 'SHARED_FILES',
        icon: 'sharedfiles.svg'
    };
    public static FAVORITE_LIST = {
        title: 'favoritelist',
        path: RouterPathConfig.FILE_MANAGEMENT_PATH.FAVORITE_LIST,
        viewType: 'favoritelist',
        status: 0,
        count: undefined,
        name: 'FAVORITE_LIST',
        icon: 'staricon.svg'
    };
    public static DELETED_FILES = {
        title: 'deletedfiles',
        path: RouterPathConfig.FILE_MANAGEMENT_PATH.DELETED_FILES,
        viewType: 'deletedfiles',
        status: 0,
        count: undefined,
        name: 'DELETED_FILES',
        icon: 'deletedfiles.svg'
    };
}
